import { render, staticRenderFns } from "./PatientResults.vue?vue&type=template&id=bc3e6806&scoped=true&"
import script from "./PatientResults.vue?vue&type=script&lang=js&"
export * from "./PatientResults.vue?vue&type=script&lang=js&"
import style0 from "./PatientResults.vue?vue&type=style&index=0&id=bc3e6806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3e6806",
  null
  
)

export default component.exports